import { useAuth } from "../context/AuthContext.jsx";
import { Navigate, useLocation } from "../vendor/runtime.js";
import { AuthLayout } from "../components/auth/AuthLayout.jsx";
import { VerifyEmailForm } from "../components/auth/VerifyEmailForm.jsx";

const VerifyEmailPage = () => {
  const { currentUser } = useAuth();
  const { state } = useLocation();

  if (currentUser) return <Navigate to="/" replace />;
  // Direct visits and refreshes can lack the registration navigation state.
  // Avoid mounting the form until the required details are available.
  if (!state?.userId || !state?.email) return <Navigate to="/login" replace />;

  return (
    <AuthLayout>
      <VerifyEmailForm userId={state.userId} email={state.email} />
    </AuthLayout>
  );
};

export { VerifyEmailPage };
